/**
 * Client presentation helpers over the shared, versioned Data View contract.
 * The shared module is the only place official templates and safe bindings are
 * defined; this file intentionally has no parallel registry to drift from it.
 */
export {
  DATA_VIEW_IDS,
  DATA_VIEW_TEMPLATE_CONTRACTS as DATA_VIEW_TEMPLATES,
  DATA_VIEW_TEMPLATE_CONTRACTS as DATA_VIEWS,
  validateDataViewBlocks,
} from "../../../shared/data-view-templates";

export type {
  DataViewId,
  DataViewBlock,
  DataViewBlockType,
  DataViewTemplateContract as DataViewTemplate,
} from "../../../shared/data-view-templates";

import { DATA_VIEW_IDS, getDataViewTemplateContract } from "../../../shared/data-view-templates";
import type { DataViewId, DataViewTemplateContract } from "../../../shared/data-view-templates";

export function isDataViewId(value: string | null): value is DataViewId {
  return !!value && (DATA_VIEW_IDS as readonly string[]).includes(value);
}

/** IDs are guarded at the route boundary, so an official template must exist. */
export function getDataView(id: DataViewId): DataViewTemplateContract {
  const template = getDataViewTemplateContract(id);
  if (!template) throw new Error(`Unknown Data View template: ${id}`);
  return template;
}
